(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b-grade-live-stock-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-gpb-root]').forEach((root) => {
    if (root.dataset.gpbReady === 'true') return;
    root.dataset.gpbReady = 'true';

    const toast = root.querySelector('[data-gpb-toast]');
    if (toast) {
      const items = Array.from(toast.querySelectorAll('[data-gpb-toast-item]'));
      const close = toast.querySelector('[data-gpb-toast-close]');
      const delay = Number(toast.dataset.delay) || 50000;
      const duration = Number(toast.dataset.duration) || 9000;
      const interval = Number(toast.dataset.interval) || 120000;
      const limit = Number(toast.dataset.limit) || 3;
      const storageKey = `gpb-stock-prompts-${root.id}`;
      let state = { count: 0, dismissed: false };
      let timer;
      let current = 0;

      try {
        state = { ...state, ...JSON.parse(sessionStorage.getItem(storageKey) || '{}') };
      } catch (error) {
        state = { count: 0, dismissed: false };
      }

      const saveState = () => {
        try {
          sessionStorage.setItem(storageKey, JSON.stringify(state));
        } catch (error) {
          return;
        }
      };

      const hideToast = () => {
        toast.classList.remove('is-visible');
        window.setTimeout(() => {
          toast.hidden = true;
          items.forEach((item) => { item.hidden = true; });
        }, 320);
      };

      const schedule = (wait) => {
        if (state.dismissed || state.count >= limit || items.length === 0) return;
        window.clearTimeout(timer);
        timer = window.setTimeout(showToast, wait);
      };

      const showToast = () => {
        if (document.hidden) {
          schedule(10000);
          return;
        }
        items.forEach((item) => { item.hidden = true; });
        items[current].hidden = false;
        toast.hidden = false;
        window.requestAnimationFrame(() => toast.classList.add('is-visible'));
        current = (current + 1) % items.length;
        state.count += 1;
        saveState();
        timer = window.setTimeout(() => {
          hideToast();
          schedule(interval);
        }, duration);
      };

      close.addEventListener('click', () => {
        state.dismissed = true;
        saveState();
        window.clearTimeout(timer);
        hideToast();
      });

      if (!state.dismissed && state.count < limit) schedule(delay);
    }

    const grid = root.querySelector('[data-gpb-grid]');
    if (!grid) return;
    const cards = Array.from(grid.querySelectorAll('[data-gpb-card]'));
    const type = root.querySelector('[data-gpb-type]');
    const availability = root.querySelector('[data-gpb-availability]');
    const price = root.querySelector('[data-gpb-price]');
    const sort = root.querySelector('[data-gpb-sort]');
    const count = root.querySelector('[data-gpb-visible-count]');
    const empty = root.querySelector('[data-gpb-empty]');
    const clear = root.querySelector('[data-gpb-clear]');
    const types = new Map();
    cards.forEach((card) => {
      if (card.dataset.type && card.dataset.typeLabel) types.set(card.dataset.type, card.dataset.typeLabel);
    });
    Array.from(types.entries()).sort((a, b) => a[1].localeCompare(b[1])).forEach(([value, label]) => {
      const option = document.createElement('option');
      option.value = value;
      option.textContent = label;
      type.append(option);
    });
    const apply = () => {
      let visible = 0;
      cards.forEach((card) => {
        const amount = Number(card.dataset.price);
        const typeMatch = type.value === 'all' || card.dataset.type === type.value;
        const availabilityMatch = availability.value === 'all' || card.dataset.availability === availability.value;
        const priceMatch = price.value === 'all' || price.value === 'under-50' && amount < 5000 || price.value === '50-100' && amount >= 5000 && amount <= 10000 || price.value === 'over-100' && amount > 10000;
        card.hidden = !(typeMatch && availabilityMatch && priceMatch);
        if (!card.hidden) visible += 1;
      });
      const ordered = [...cards].sort((a, b) => {
        if (sort.value === 'price-low') return Number(a.dataset.price) - Number(b.dataset.price);
        if (sort.value === 'price-high') return Number(b.dataset.price) - Number(a.dataset.price);
        if (sort.value === 'stock-low') return Number(a.dataset.stock) - Number(b.dataset.stock);
        return Number(a.dataset.order) - Number(b.dataset.order);
      });
      ordered.forEach((card) => grid.append(card));
      count.textContent = String(visible);
      empty.hidden = visible !== 0;
    };
    [type, availability, price, sort].forEach((control) => control.addEventListener('change', apply));
    clear.addEventListener('click', () => {
      type.value = 'all';
      availability.value = 'all';
      price.value = 'all';
      sort.value = 'featured';
      apply();
    });
    apply();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp-article-guide"]) return;
  try {
    
if (!customElements.get('gp-article-guide')) {
  customElements.define('gp-article-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const body = this.querySelector('[data-guide-body]');
      if (!body) return;
      const list = this.querySelector('.gp-guide__toc');
      const headings = body.querySelectorAll('h2');
      if (list && headings.length) {
        headings.forEach((heading, index) => {
          if (!heading.id) heading.id = this.id + '-heading-' + index;
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = '#' + encodeURIComponent(heading.id);
          link.textContent = heading.textContent;
          item.append(link);
          list.append(item);
        });
        this.querySelector('.gp-guide__aside').hidden = false;
        if (window.matchMedia('(max-width: 900px)').matches) this.querySelector('details').open = false;
      }
      body.querySelectorAll('table').forEach(table => {
        table.tabIndex = 0;
        if (!table.getAttribute('aria-label') && !table.querySelector('caption')) table.setAttribute('aria-label', this.dataset.tableLabel);
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp-black-friday-2026"] && !Shopify.designMode) return;
  try {
    

  (()=>{const roots=document.querySelectorAll('[data-gp-bf]');roots.forEach(root=>{const timer=root.querySelector('[data-countdown]');if(!timer)return;const target=Date.parse(timer.dataset.end);const fallback=timer.querySelector('.gp-bf__countdown-fallback');if(Number.isNaN(target)){timer.querySelector('.gp-bf__countdown-grid').hidden=true;fallback.style.display='block';return}const fields={days:timer.querySelector('[data-days]'),hours:timer.querySelector('[data-hours]'),minutes:timer.querySelector('[data-minutes]'),seconds:timer.querySelector('[data-seconds]')};const tick=()=>{const distance=target-Date.now();if(distance<=0){Object.values(fields).forEach(field=>field.textContent='00');timer.querySelector('.gp-bf__countdown-grid').hidden=true;fallback.style.display='block';return false}fields.days.textContent=String(Math.floor(distance/86400000)).padStart(2,'0');fields.hours.textContent=String(Math.floor(distance%86400000/3600000)).padStart(2,'0');fields.minutes.textContent=String(Math.floor(distance%3600000/60000)).padStart(2,'0');fields.seconds.textContent=String(Math.floor(distance%60000/1000)).padStart(2,'0');return true};tick();const interval=setInterval(()=>{if(!tick())clearInterval(interval)},1000)})})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp-bundle-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!window.gpBundleTrackingReady) {
    window.gpBundleTrackingReady = true;

    document.addEventListener('click', function (event) {
      const link = event.target.closest('[data-gp-bundle-link]');
      if (!link) return;

      const promotion = {
        promotion_id: link.dataset.promotionId,
        promotion_name: link.dataset.promotionName,
        creative_slot: link.dataset.creativeSlot,
        items: [
          {
            item_id: link.dataset.itemId,
            item_name: link.dataset.itemName
          }
        ]
      };

      if (typeof window.gtag === 'function') {
        window.gtag('event', 'select_promotion', promotion);
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'select_promotion',
          ecommerce: promotion
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp-cable-stack-article"] && !Shopify.designMode) return;
  try {
    
  const roots = document.querySelectorAll('[data-gp-csa]');

  roots.forEach((root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const body = root.querySelector('[data-gp-csa-body]');
    const desktopList = root.querySelector('[data-gp-csa-links]');
    const mobileList = root.querySelector('[data-gp-csa-mobile-links]');
    const progress = root.querySelector('[data-gp-csa-progress]');
    const headings = body ? [...body.querySelectorAll('h2')] : [];

    const slugify = (value, index) => {
      const slug = value.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      return slug || `section-${index + 1}`;
    };

    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = slugify(heading.textContent, index);
      const desktopItem = document.createElement('li');
      const desktopLink = document.createElement('a');
      desktopLink.href = `#${heading.id}`;
      desktopLink.textContent = heading.textContent;
      desktopItem.append(desktopLink);
      desktopList?.append(desktopItem);

      const mobileLink = desktopLink.cloneNode(true);
      mobileList?.append(mobileLink);
    });

    const faqHeading = headings.find((heading) => heading.textContent.toLowerCase().includes('frequently asked questions'));
    if (faqHeading) {
      const faqList = document.createElement('div');
      faqList.className = 'gp-csa__faq-list';
      let node = faqHeading.nextElementSibling;

      while (node && node.tagName !== 'H2') {
        const next = node.nextElementSibling;
        if (node.tagName === 'H3') {
          const details = document.createElement('details');
          details.className = 'gp-csa__faq';
          const summary = document.createElement('summary');
          summary.textContent = node.textContent;
          const content = document.createElement('div');
          content.className = 'gp-csa__faq-content';
          let answer = next;
          while (answer && answer.tagName !== 'H3' && answer.tagName !== 'H2') {
            const answerNext = answer.nextElementSibling;
            content.append(answer);
            answer = answerNext;
          }
          details.append(summary, content);
          faqList.append(details);
          node.remove();
          node = answer;
          continue;
        }
        node = next;
      }
      faqHeading.insertAdjacentElement('afterend', faqList);
    }

    const updateProgress = () => {
      if (!progress) return;
      const start = root.offsetTop;
      const distance = root.offsetHeight - window.innerHeight;
      const amount = distance > 0 ? Math.min(1, Math.max(0, (window.scrollY - start) / distance)) : 0;
      progress.style.transform = `scaleX(${amount})`;
    };

    const markActive = () => {
      const current = [...headings].reverse().find((heading) => heading.getBoundingClientRect().top <= 140);
      root.querySelectorAll('[data-gp-csa-links] a').forEach((link) => {
        link.classList.toggle('is-active', current && link.getAttribute('href') === `#${current.id}`);
      });
    };

    document.addEventListener('scroll', () => {
      updateProgress();
      markActive();
    }, { passive: true });
    updateProgress();
    markActive();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp-campaign-engine"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '.gp-campaign-engine';
  const daysMs = days => Number(days || 0) * 86400000;
  const parseTime = value => value ? Date.parse(value) : NaN;
  const read = key => {
    try { return JSON.parse(localStorage.getItem(key)); } catch { return null; }
  };
  const write = (key, value) => {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch {}
  };
  const validUntil = record => record && Number(record.expires || 0) > Date.now();

  const getPrivacy = () => {
    try {
      const cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.currentVisitorConsent !== 'function') return null;
      const consent = cp.currentVisitorConsent() || {};
      return {
        preferences: consent.preferences === 'yes' || consent.preferences === true,
        analytics: consent.analytics === 'yes' || consent.analytics === true
      };
    } catch {
      return null;
    }
  };

  const ensurePrivacy = () => new Promise(resolve => {
    const current = getPrivacy();
    if (current) {
      resolve(current);
      return;
    }
    try {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {
          resolve(getPrivacy() || { preferences: false, analytics: false });
        });
        return;
      }
    } catch {}
    resolve({ preferences: false, analytics: false });
  });

  const init = root => {
    if (!root || root.dataset.enabled !== 'true' || root.dataset.gpReady === '1') return;
    root.dataset.gpReady = '1';

    const urlTestMode = new URLSearchParams(window.location.search).get('gp_campaign_test') === '1';
    const testMode = root.dataset.testMode === 'true' || urlTestMode;
    const campaignId = root.dataset.campaignId || 'bgrade';
    const now = Date.now();
    const start = parseTime(root.dataset.start);
    const end = parseTime(root.dataset.end);

    if (!testMode) {
      if (!Number.isNaN(start) && now < start) return;
      if (!Number.isNaN(end) && now > end) return;
    }

    const track = (name, detail = {}) => {
      if (testMode) return;
      const privacy = getPrivacy();
      if (!privacy || !privacy.analytics) return;
      const payload = { event: name, campaign_id: campaignId, ...detail };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      if (typeof window.gtag === 'function') window.gtag('event', name, detail);
    };

    const campaignSeenKey = `gp_campaign_seen_${campaignId}`;
    const newOnly = root.dataset.newOnly === 'true';
    const markSeen = () => {
      if (testMode) return;
      const privacy = getPrivacy();
      if (!privacy || !privacy.preferences) return;
      write(campaignSeenKey, { expires: Date.now() + daysMs(root.dataset.seenDays || 30) });
    };

    const stockNode = root.querySelector('[data-gp-stock]');
    let stock = [];
    try { stock = JSON.parse(stockNode?.textContent || '[]'); } catch {}

    const toast = root.querySelector('[data-gp-toast]');
    const toastClose = root.querySelector('[data-gp-close]');
    let toastTimer;
    let toastIndex = 0;
    let toastCount = 0;

    const hideToast = () => {
      if (!toast) return;
      toast.classList.remove('is-visible');
      setTimeout(() => { toast.hidden = true; }, 300);
    };

    const renderToast = item => {
      if (!toast || !item) return;
      const img = root.querySelector('[data-gp-toast-image]');
      if (img) {
        img.src = item.image || '';
        img.alt = item.title || '';
      }
      const title = root.querySelector('[data-gp-toast-title]');
      const price = root.querySelector('[data-gp-toast-price]');
      const stockText = root.querySelector('[data-gp-toast-stock]');
      const link = root.querySelector('[data-gp-toast-link]');
      if (title) title.textContent = item.title || '';
      if (price) price.textContent = item.price ? `B-Grade from ${item.price}` : '';
      if (stockText) stockText.textContent = item.inventory === 1 ? 'Only 1 remaining in B-Grade' : `Only ${item.inventory} remaining in B-Grade`;
      if (link) link.href = root.dataset.landingUrl || '/pages/b-grade';
      toast.hidden = false;
      requestAnimationFrame(() => toast.classList.add('is-visible'));
      toastCount += 1;
      markSeen();
      track('campaign_impression', {
        campaign_type: 'stock_toast',
        recommended_product: item.handle,
        inventory_at_impression: item.inventory,
        page_type: 'home'
      });
    };

    const cycleToast = () => {
      if (!stock.length || toastCount >= Number(root.dataset.toastMax || 3)) return;
      renderToast(stock[toastIndex % stock.length]);
      toastIndex += 1;
      if (toastCount < Number(root.dataset.toastMax || 3)) {
        const gap = testMode ? 5000 : Number(root.dataset.toastGap || 55000);
        toastTimer = setTimeout(() => {
          hideToast();
          setTimeout(cycleToast, 350);
        }, gap);
      }
    };

    toastClose?.addEventListener('click', event => {
      event.preventDefault();
      clearTimeout(toastTimer);
      hideToast();
      markSeen();
      track('campaign_dismiss', { campaign_type: 'stock_toast' });
    });

    root.querySelector('[data-gp-toast-link]')?.addEventListener('click', () => {
      markSeen();
      track('campaign_click', {
        campaign_type: 'stock_toast',
        destination: root.dataset.landingUrl || '/pages/b-grade'
      });
    });

    if (root.dataset.home === 'true' && stock.length) {
      if (testMode) {
        setTimeout(cycleToast, 1200);
      } else {
        ensurePrivacy().then(privacy => {
          const seen = read(campaignSeenKey);
          const isNewVisitor = !validUntil(seen);
          if (!newOnly || (privacy.preferences && isNewVisitor)) {
            setTimeout(cycleToast, Number(root.dataset.toastDelay || 10000));
          }
        });
      }
    }

    const offerNode = root.querySelector('[data-gp-offer]');
    let offer = null;
    try { offer = JSON.parse(offerNode?.textContent || 'null'); } catch {}
    if (!offer || root.dataset.product !== 'true') return;

    const normalizeSku = sku => String(sku || '').toUpperCase().replace(/^B-GRADE-/, '');
    const selectedSourceVariant = () => {
      const inputs = Array.from(document.querySelectorAll('form[action*="/cart/add"] [name="id"]'));
      const selectedId = inputs.find(input => input.value)?.value || new URLSearchParams(window.location.search).get('variant');
      return (offer.sourceVariants || []).find(variant => String(variant.id) === String(selectedId)) || (offer.sourceVariants || [])[0] || null;
    };
    const matchedOfferVariant = sourceVariant => {
      if (!sourceVariant || !sourceVariant.sku) return null;
      const sourceSku = normalizeSku(sourceVariant.sku);
      return (offer.offerVariants || []).find(variant => normalizeSku(variant.sku) === sourceSku) || null;
    };

    const sourceSuppressKey = `gp_campaign_source_suppress_${offer.sourceId}`;
    const sourceSuppressed = () => !testMode && validUntil(read(sourceSuppressKey));
    const suppressSource = () => {
      if (testMode) return;
      write(sourceSuppressKey, { expires: Date.now() + daysMs(root.dataset.suppressDays || 30) });
    };

    const drawer = root.querySelector('[data-gp-drawer]');
    const drawerClose = root.querySelector('[data-gp-drawer-close]');

    const setDrawerClearance = () => {
      if (!drawer) return;
      const base = window.matchMedia('(max-width: 640px)').matches ? 10 : 18;
      let requiredBottom = base;
      const selectors = [
        'iframe',
        '[aria-label*=\"chat\" i]',
        '[aria-label*=\"support\" i]',
        '[class*=\"chat\" i]',
        '[id*=\"chat\" i]',
        '[class*=\"inbox\" i]',
        '[id*=\"inbox\" i]'
      ];
      const candidates = Array.from(document.querySelectorAll(selectors.join(',')));
      for (const el of candidates) {
        if (root.contains(el)) continue;
        const rect = el.getBoundingClientRect();
        if (!rect.width || !rect.height) continue;
        if (rect.width > 260 || rect.height > 180) continue;
        if (rect.right < window.innerWidth - 280) continue;
        if (rect.bottom < window.innerHeight - 180) continue;
        const style = getComputedStyle(el);
        if (style.visibility === 'hidden' || style.display === 'none' || Number(style.opacity || 1) === 0) continue;
        const parentPosition = el.parentElement ? getComputedStyle(el.parentElement).position : '';
        const fixedLike = style.position === 'fixed' || style.position === 'sticky' || parentPosition === 'fixed' || parentPosition === 'sticky';
        if (!fixedLike) continue;
        requiredBottom = Math.max(requiredBottom, Math.ceil(window.innerHeight - rect.top + 14));
      }
      root.style.setProperty('--gp-drawer-bottom', `${requiredBottom}px`);
    };

    let clearanceFrame = 0;
    const scheduleDrawerClearance = () => {
      cancelAnimationFrame(clearanceFrame);
      clearanceFrame = requestAnimationFrame(setDrawerClearance);
    };
    scheduleDrawerClearance();
    window.addEventListener('resize', scheduleDrawerClearance, { passive: true });
    const clearanceObserver = new MutationObserver(scheduleDrawerClearance);
    clearanceObserver.observe(document.body, { childList: true, subtree: true });

    const hideDrawer = () => {
      if (!drawer) return;
      drawer.classList.remove('is-visible');
      drawer.setAttribute('aria-hidden', 'true');
      setTimeout(() => { drawer.hidden = true; }, 380);
    };

    const cartHasSource = async () => {
      if (testMode) return false;
      try {
        const response = await fetch('/cart.js', { credentials: 'same-origin' });
        const cart = await response.json();
        return Array.isArray(cart.items) && cart.items.some(item => String(item.product_id) === String(offer.sourceId));
      } catch {
        return false;
      }
    };

    const showDrawer = async () => {
      if (!drawer || sourceSuppressed()) return;
      setDrawerClearance();
      if (await cartHasSource()) {
        suppressSource();
        return;
      }
      const sourceVariant = selectedSourceVariant();
      const offerVariant = matchedOfferVariant(sourceVariant);
      if (!sourceVariant || !offerVariant) return;
      const variantDiscount = sourceVariant.priceCents > offerVariant.priceCents
        ? Math.round(((sourceVariant.priceCents - offerVariant.priceCents) * 100) / sourceVariant.priceCents)
        : 0;
      const img = root.querySelector('[data-gp-drawer-image]');
      if (img) {
        img.src = offer.offerImage || '';
        img.alt = offer.offerTitle || '';
      }
      const title = root.querySelector('[data-gp-drawer-title]');
      const sourcePrice = root.querySelector('[data-gp-drawer-source-price]');
      const offerPrice = root.querySelector('[data-gp-drawer-price]');
      const discount = root.querySelector('[data-gp-drawer-discount]');
      const stockText = root.querySelector('[data-gp-drawer-stock-text]');
      const link = root.querySelector('[data-gp-drawer-link]');
      if (title) title.textContent = offer.offerTitle || '';
      if (sourcePrice) sourcePrice.textContent = sourceVariant.price || offer.sourcePrice || '';
      if (offerPrice) offerPrice.textContent = offerVariant.price || offer.offerPrice || '';
      if (discount) discount.textContent = variantDiscount > 0 ? `${variantDiscount}% BELOW STANDARD PRICE` : 'B-GRADE PRICE';
      if (stockText) stockText.textContent = offerVariant.inventory === 1 ? 'ONLY 1 OF THIS B-GRADE OPTION LEFT' : `ONLY ${offerVariant.inventory} OF THIS B-GRADE OPTION LEFT`;
      if (link) {
        const offerUrl = new URL(offer.offerUrl || '#', window.location.origin);
        offerUrl.searchParams.set('variant', offerVariant.id);
        link.href = offerUrl.pathname + offerUrl.search;
      }
      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(() => drawer.classList.add('is-visible'));
      track('campaign_impression', {
        campaign_type: 'product_drawer',
        source_product: offer.sourceHandle,
        recommended_product: offer.offerHandle,
        inventory_at_impression: offerVariant.inventory,
        discount_percent: variantDiscount,
        source_variant: sourceVariant.sku,
        recommended_variant: offerVariant.sku,
        page_type: 'product'
      });
    };

    drawerClose?.addEventListener('click', () => {
      hideDrawer();
      if (!testMode) {
        write(`gp_campaign_drawer_dismiss_${campaignId}_${offer.sourceId}`, { expires: Date.now() + daysMs(7) });
      }
      track('campaign_dismiss', {
        campaign_type: 'product_drawer',
        source_product: offer.sourceHandle,
        recommended_product: offer.offerHandle
      });
    });

    root.querySelector('[data-gp-drawer-link]')?.addEventListener('click', () => {
      track('campaign_click', {
        campaign_type: 'product_drawer',
        source_product: offer.sourceHandle,
        recommended_product: offer.offerHandle
      });
    });

    document.addEventListener('click', event => {
      const target = event.target.closest('button,a,input[type="submit"]');
      if (!target) return;
      const label = `${target.getAttribute('name') || ''} ${target.getAttribute('href') || ''} ${target.textContent || ''}`.toLowerCase();
      const isCheckout = label.includes('checkout') || target.closest('.shopify-payment-button');
      const isAdd = label.includes('add to cart') || target.getAttribute('name') === 'add';
      if (isCheckout || isAdd) suppressSource();
    }, true);

    const dismissed = testMode ? null : read(`gp_campaign_drawer_dismiss_${campaignId}_${offer.sourceId}`);
    if (!sourceSuppressed() && !validUntil(dismissed)) {
      setTimeout(showDrawer, testMode ? 1500 : Number(root.dataset.drawerDelay || 20000));
    }
  };

  const initAll = scope => {
    if (scope.matches?.(selector)) init(scope);
    scope.querySelectorAll?.(selector).forEach(init);
  };

  initAll(document);
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp-gift-strong-2026"] && !Shopify.designMode) return;
  try {
    
function gsEnable(root){root.querySelectorAll('[data-gs-copy]').forEach(button=>{button.hidden=false;});}
gsEnable(document);
document.addEventListener('shopify:section:load',event=>gsEnable(event.target));
document.addEventListener('click',async event=>{const button=event.target.closest('[data-gs-copy]');if(!button)return;const card=button.closest('.gs26-card-body');const field=card.querySelector('textarea');const status=card.querySelector('[role="status"]');try{await navigator.clipboard.writeText(field.value);status.textContent=button.dataset.success;}catch(error){field.focus();field.select();status.textContent=button.dataset.fail;}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp-main-product-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (scope = document) => {
      scope.querySelectorAll('.gp-pdp-v2:not([data-gp-v2-ready])').forEach((root) => {
        root.setAttribute('data-gp-v2-ready', 'true');

        const mainButton = root.querySelector('[data-gp-v2-main-atc]');
        const mainPrice = root.querySelector('[data-product-price]');
        const buttonPrice = root.querySelector('[data-gp-v2-button-price]');
        const sticky = root.querySelector('[data-gp-v2-sticky]');
        const stickyButton = root.querySelector('[data-gp-v2-sticky-button]');
        const stickyText = root.querySelector('[data-gp-v2-sticky-text]');
        const stickyPrice = root.querySelector('[data-gp-v2-sticky-price]');
        const variantSelect = root.querySelector('[data-product-select]');
        const taxNotice = root.querySelector('[data-gp-v2-tax-notice]');
        const policyRow = root.querySelector('[data-gp-v2-policy-row]');
        const thumbDock = root.querySelector('[data-product-thumbs]');
        const thumbScroller = root.querySelector('.gp-v2__thumb-scroller');
        const thumbPrevious = root.querySelector('[data-gp-v2-thumb-prev]');
        const thumbNext = root.querySelector('[data-gp-v2-thumb-next]');
        let pendingSource = 'main';
        let thumbUpdateFrame;

        const cleanText = (node) => node ? node.textContent.replace(/\s+/g, ' ').trim() : '';

        const syncPurchaseState = () => {
          const price = cleanText(mainPrice);
          const label = cleanText(mainButton?.querySelector('[data-add-to-cart-text]'));
          const disabled = !mainButton || mainButton.disabled;

          if (buttonPrice) {
            const nextPrice = `— ${price}`;
            if (buttonPrice.textContent.trim() !== nextPrice) buttonPrice.textContent = nextPrice;
            buttonPrice.classList.toggle('hide', disabled);
          }

          if (stickyPrice && stickyPrice.textContent.trim() !== price) stickyPrice.textContent = price;
          if (stickyText && stickyText.textContent.trim() !== label) stickyText.textContent = label;
          if (stickyButton) stickyButton.disabled = disabled;

          if (taxNotice) {
            const selectedVariant = variantSelect?.selectedOptions?.[0];
            taxNotice.hidden = selectedVariant?.dataset.taxable !== 'true';
          }

          if (policyRow) {
            const hasShippingPolicy = policyRow.dataset.hasShippingPolicy === 'true';
            policyRow.hidden = !hasShippingPolicy && (!taxNotice || taxNotice.hidden);
          }
        };

        const syncThumbDock = () => {
          if (!thumbDock || !thumbScroller) return;
          cancelAnimationFrame(thumbUpdateFrame);
          thumbUpdateFrame = requestAnimationFrame(() => {
            const dockStyle = window.getComputedStyle(thumbDock);
            const dockPadding = parseFloat(dockStyle.paddingLeft) + parseFloat(dockStyle.paddingRight);
            const availableWidth = thumbDock.clientWidth - dockPadding;
            const isOverflowing = thumbScroller.scrollWidth > availableWidth + 2;
            thumbDock.classList.toggle('gp-v2__thumbs--overflowing', isOverflowing);
            thumbDock.classList.toggle('gp-v2__thumbs--fits', !isOverflowing);
            const maximumScroll = Math.max(0, thumbScroller.scrollWidth - thumbScroller.clientWidth);

            if (!isOverflowing) thumbScroller.scrollLeft = 0;

            if (thumbPrevious) {
              thumbPrevious.hidden = !isOverflowing;
              thumbPrevious.disabled = thumbScroller.scrollLeft <= 2;
            }

            if (thumbNext) {
              thumbNext.hidden = !isOverflowing;
              thumbNext.disabled = thumbScroller.scrollLeft >= maximumScroll - 2;
            }
          });
        };

        const moveThumbDock = (direction) => {
          if (!thumbScroller) return;
          const distance = Math.max(160, thumbScroller.clientWidth * .72);
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          thumbScroller.scrollBy({
            left: distance * direction,
            behavior: reduceMotion ? 'auto' : 'smooth'
          });
        };

        thumbPrevious?.addEventListener('click', () => moveThumbDock(-1));
        thumbNext?.addEventListener('click', () => moveThumbDock(1));
        thumbScroller?.addEventListener('scroll', syncThumbDock, { passive: true });

        if (thumbScroller && 'ResizeObserver' in window) {
          const thumbResizeObserver = new ResizeObserver(syncThumbDock);
          thumbResizeObserver.observe(thumbScroller);
          thumbScroller.querySelectorAll('.product__thumb-item').forEach((item) => thumbResizeObserver.observe(item));
        }

        if (thumbScroller) {
          new MutationObserver(syncThumbDock).observe(thumbScroller, {
            attributes: true,
            subtree: true,
            attributeFilter: ['class', 'hidden', 'style']
          });
        }

        if (mainButton) {
          new MutationObserver(syncPurchaseState).observe(mainButton, {
            attributes: true,
            attributeFilter: ['disabled'],
            childList: true,
            subtree: true
          });

          mainButton.addEventListener('click', () => {
            root.dispatchEvent(new CustomEvent('gp:pdp:add-to-cart-click', {
              bubbles: true,
              detail: {
                productId: root.dataset.productId,
                variantId: variantSelect?.value || '',
                source: pendingSource
              }
            }));
            pendingSource = 'main';
          });
        }

        if (mainPrice) {
          new MutationObserver(syncPurchaseState).observe(mainPrice, {
            childList: true,
            subtree: true,
            characterData: true
          });
        }

        if (sticky && mainButton) {
          new IntersectionObserver(([entry]) => {
            const passedMainButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            sticky.hidden = !passedMainButton;
          }, { threshold: 0.01 }).observe(mainButton);
        }

        stickyButton?.addEventListener('click', () => {
          if (!mainButton || mainButton.disabled) return;
          pendingSource = 'sticky';
          mainButton.click();
        });

        root.querySelectorAll('[data-product-thumb]').forEach((thumb) => {
          thumb.addEventListener('click', () => {
            root.querySelectorAll('[data-product-thumb]').forEach((item) => item.setAttribute('aria-current', 'false'));
            thumb.setAttribute('aria-current', 'true');
            const counter = root.querySelector('[data-gp-v2-media-current]');
            if (counter) counter.textContent = String(Number(thumb.dataset.index) + 1);
          });
        });

        root.addEventListener('variant:change', () => requestAnimationFrame(() => {
          syncPurchaseState();
          syncThumbDock();
        }));
        variantSelect?.addEventListener('change', () => requestAnimationFrame(() => {
          syncPurchaseState();
          syncThumbDock();
        }));
        syncPurchaseState();
        syncThumbDock();
      });
    };

    const revealPaymentButtons = (scope = document) => {
      const root = scope.querySelectorAll ? scope : document;
      root.querySelectorAll('.shopify-payment-button').forEach((button) => {
        if (button.querySelector('shopify-accelerated-checkout')) {
          button.style.removeProperty('display');
        }
      });
    };

    const initPaymentButtons = (scope = document) => {
      const reveal = () => revealPaymentButtons(scope);
      reveal();

      if (window.customElements && typeof window.customElements.whenDefined === 'function') {
        window.customElements.whenDefined('shopify-accelerated-checkout').then(() => {
          requestAnimationFrame(reveal);
        });
      }

      [250, 750, 1500].forEach((delay) => setTimeout(reveal, delay));
    };

    init();
    initPaymentButtons();
    window.addEventListener('load', () => initPaymentButtons(), { once: true });
    document.addEventListener('shopify:section:load', (event) => {
      init(event.target);
      initPaymentButtons(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp-minipin-product-content"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseTabs = (root) => {
      root.querySelectorAll('[data-gp-tabs]').forEach((tabs) => {
        if (tabs.dataset.gpTabsReady === 'true') return;

        const buttons = Array.from(tabs.querySelectorAll('[data-gp-tab]'));
        const panels = Array.from(tabs.querySelectorAll('[data-gp-tab-panel]'));
        if (!buttons.length || buttons.length !== panels.length) return;

        const activate = (nextIndex, moveFocus = false) => {
          buttons.forEach((button, index) => {
            const isActive = index === nextIndex;
            button.setAttribute('aria-selected', String(isActive));
            button.setAttribute('tabindex', isActive ? '0' : '-1');
            panels[index].hidden = !isActive;
          });

          if (moveFocus) buttons[nextIndex].focus();
        };

        buttons.forEach((button, index) => {
          button.addEventListener('click', () => activate(index));
          button.addEventListener('keydown', (event) => {
            let nextIndex = index;

            if (event.key === 'ArrowRight') nextIndex = (index + 1) % buttons.length;
            if (event.key === 'ArrowLeft') nextIndex = (index - 1 + buttons.length) % buttons.length;
            if (event.key === 'Home') nextIndex = 0;
            if (event.key === 'End') nextIndex = buttons.length - 1;
            if (nextIndex === index) return;

            event.preventDefault();
            activate(nextIndex, true);
          });
        });

        tabs.dataset.gpTabsReady = 'true';
        activate(0);
      });
    };

    initialiseTabs(document);
    document.addEventListener('shopify:section:load', (event) => initialiseTabs(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp-nutrition-article"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-gp-na]').forEach((root)=>{if(root.dataset.ready==='true')return;root.dataset.ready='true';const body=root.querySelector('[data-gp-na-body]');const desktopList=root.querySelector('[data-gp-na-links]');const mobileList=root.querySelector('[data-gp-na-mobile-links]');const progress=root.querySelector('[data-gp-na-progress]');const headings=body?[...body.querySelectorAll('h2')]:[];const preferredIds=new Map([['what is a cheat day?','what-is-a-cheat-day'],['why have a cheat day?','cheat-day-benefits'],['what to eat on a cheat day','what-to-eat-on-a-cheat-day'],['how to eat on a cheat day','how-to-plan-a-cheat-day'],['should a cheat day exceed daily caloric intake?','cheat-day-calories'],['potential downsides of cheat days','cheat-day-downsides'],['alternatives to cheat days','cheat-day-alternatives'],['conclusion','cheat-day-conclusion']]);const slugify=(value,index)=>{const preferred=preferredIds.get(value.toLowerCase().trim());if(preferred)return preferred;const slug=value.toLowerCase().trim().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');return slug||`section-${index+1}`};headings.forEach((heading,index)=>{if(!heading.id)heading.id=slugify(heading.textContent,index);const item=document.createElement('li');const link=document.createElement('a');link.href=`#${heading.id}`;link.textContent=heading.textContent;item.append(link);desktopList?.append(item);mobileList?.append(link.cloneNode(true))});const update=()=>{if(progress){const start=root.offsetTop;const distance=root.offsetHeight-window.innerHeight;const amount=distance>0?Math.min(1,Math.max(0,(window.scrollY-start)/distance)):0;progress.style.transform=`scaleX(${amount})`}const current=[...headings].reverse().find((heading)=>heading.getBoundingClientRect().top<=140);root.querySelectorAll('[data-gp-na-links] a').forEach((link)=>link.classList.toggle('is-active',Boolean(current)&&link.getAttribute('href')===`#${current.id}`))};document.addEventListener('scroll',update,{passive:true});update()});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp-olympia-editorial"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function slugify(value) {
      return value
        .toLowerCase()
        .trim()
        .replace(/['’]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    function copyText(value) {
      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(value);
      }

      return new Promise(function (resolve, reject) {
        var textarea = document.createElement('textarea');
        textarea.value = value;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();

        try {
          document.execCommand('copy');
          resolve();
        } catch (error) {
          reject(error);
        }

        document.body.removeChild(textarea);
      });
    }

    function initialiseArticle(root) {
      var article = root.querySelector('[data-gp-olympia-article]');
      if (!article) return;

      var progress = article.querySelector('[data-gp-progress]');
      if (progress) {
        var updateProgress = function () {
          var rect = article.getBoundingClientRect();
          var scrollable = article.offsetHeight - window.innerHeight;
          var travelled = Math.min(Math.max(-rect.top, 0), Math.max(scrollable, 1));
          progress.style.width = Math.min((travelled / Math.max(scrollable, 1)) * 100, 100) + '%';
        };

        updateProgress();
        window.addEventListener('scroll', updateProgress, { passive: true });
        window.addEventListener('resize', updateProgress);
      }

      var body = article.querySelector('[data-gp-article-body]');
      var toc = article.querySelector('[data-gp-toc] ol');

      function insertFeatureAfterHeading(templateSelector, headingText) {
        if (!body) return;

        var template = article.querySelector(templateSelector);
        if (!template || !template.content) return;

        var headings = body.querySelectorAll('.gp-oly-copy h2');
        var target = Array.prototype.find.call(headings, function (heading) {
          return heading.textContent.trim().toLowerCase() === headingText.toLowerCase();
        });

        if (!target || target.dataset.gpFeatureAdded === 'true') return;

        target.dataset.gpFeatureAdded = 'true';
        target.insertAdjacentElement('afterend', template.content.firstElementChild.cloneNode(true));
      }

      insertFeatureAfterHeading(
        '[data-gp-sandow-template]',
        'Before Olympia: the physical culture roots of bodybuilding'
      );

      insertFeatureAfterHeading(
        '[data-gp-vegas-template]',
        'Olympia 2026: what’s happening in Las Vegas?'
      );

      if (body && toc) {
        var headings = body.querySelectorAll('.gp-oly-copy h2, .gp-oly-copy h3, .gp-oly-roster > .gp-oly-section-heading h2');

        headings.forEach(function (heading, index) {
          if (!heading.id) {
            heading.id = slugify(heading.textContent) || 'section-' + (index + 1);
          }

          var item = document.createElement('li');
          var link = document.createElement('a');
          link.href = '#' + heading.id;
          link.textContent = heading.textContent;

          if (heading.tagName.toLowerCase() === 'h3') {
            item.style.marginLeft = '12px';
          }

          item.appendChild(link);
          toc.appendChild(item);
        });
      }

      var promo = article.querySelector('[data-gp-promo]');
      if (promo) {
        var start = new Date(promo.dataset.start);
        var end = new Date(promo.dataset.end);
        var now = new Date();
        var validDates = !Number.isNaN(start.getTime()) && !Number.isNaN(end.getTime());
        var isLive = validDates && now >= start && now < end;
        var isEditor = Boolean(window.Shopify && window.Shopify.designMode);

        promo.hidden = !(isLive || isEditor);

        var copyButton = promo.querySelector('[data-copy-code]');
        var copyStatus = promo.querySelector('[data-copy-status]');

        if (copyButton) {
          copyButton.addEventListener('click', function () {
            var original = copyButton.textContent;
            var code = promo.dataset.code || '';

            copyText(code).then(function () {
              copyButton.textContent = 'Copied';
              if (copyStatus) copyStatus.textContent = 'Copied discount code ' + code;

              window.setTimeout(function () {
                copyButton.textContent = original;
                if (copyStatus) copyStatus.textContent = '';
              }, 1600);
            });
          });
        }
      }
    }

    initialiseArticle(document);

    document.addEventListener('shopify:section:load', function (event) {
      initialiseArticle(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp-olympia-weekend-offer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function copyText(value) {
      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(value);
      }

      return new Promise(function (resolve, reject) {
        var textarea = document.createElement('textarea');
        textarea.value = value;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();

        try {
          document.execCommand('copy');
          resolve();
        } catch (error) {
          reject(error);
        }

        document.body.removeChild(textarea);
      });
    }

    function initialise(section) {
      if (!section || section.dataset.gpInitialised === 'true') return;

      section.dataset.gpInitialised = 'true';

      var start = new Date(section.dataset.start);
      var end = new Date(section.dataset.end);
      var now = new Date();
      var validDates = !Number.isNaN(start.getTime()) && !Number.isNaN(end.getTime());
      var isLive = validDates && now >= start && now < end;
      var isEditor = Boolean(window.Shopify && window.Shopify.designMode);

      section.hidden = !(isLive || isEditor);

      var liveBadge = section.querySelector('[data-live-badge]');
      if (liveBadge && !isLive && isEditor) {
        liveBadge.style.opacity = '.45';
      }

      var button = section.querySelector('[data-copy-code]');
      var status = section.querySelector('[data-copy-status]');

      if (button) {
        button.addEventListener('click', function () {
          var originalLabel = button.dataset.copyLabel || button.textContent;
          var copiedLabel = button.dataset.copiedLabel || 'Copied';
          var code = section.dataset.code || '';

          copyText(code).then(function () {
            button.textContent = copiedLabel;
            if (status) status.textContent = copiedLabel + ': ' + code;

            window.setTimeout(function () {
              button.textContent = originalLabel;
              if (status) status.textContent = '';
            }, 1600);
          });
        });
      }
    }

    function initialiseAll(root) {
      var scope = root || document;
      scope.querySelectorAll('[data-gp-olympia-promo]').forEach(initialise);
    }

    initialiseAll(document);

    document.addEventListener('shopify:section:load', function (event) {
      initialiseAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp-tbar-product-content"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseTabs = (root) => {
      root.querySelectorAll('[data-gp-tabs]').forEach((tabs) => {
        if (tabs.dataset.gpTabsReady === 'true') return;

        const buttons = Array.from(tabs.querySelectorAll('[data-gp-tab]'));
        const panels = Array.from(tabs.querySelectorAll('[data-gp-tab-panel]'));
        if (!buttons.length || buttons.length !== panels.length) return;

        const activate = (nextIndex, moveFocus = false) => {
          buttons.forEach((button, index) => {
            const isActive = index === nextIndex;
            button.setAttribute('aria-selected', String(isActive));
            button.setAttribute('tabindex', isActive ? '0' : '-1');
            panels[index].hidden = !isActive;
          });

          if (moveFocus) buttons[nextIndex].focus();
        };

        buttons.forEach((button, index) => {
          button.addEventListener('click', () => activate(index));
          button.addEventListener('keydown', (event) => {
            let nextIndex = index;

            if (event.key === 'ArrowRight') nextIndex = (index + 1) % buttons.length;
            if (event.key === 'ArrowLeft') nextIndex = (index - 1 + buttons.length) % buttons.length;
            if (event.key === 'Home') nextIndex = 0;
            if (event.key === 'End') nextIndex = buttons.length - 1;
            if (nextIndex === index) return;

            event.preventDefault();
            activate(nextIndex, true);
          });
        });

        tabs.dataset.gpTabsReady = 'true';
        activate(0);
      });
    };

    initialiseTabs(document);
    document.addEventListener('shopify:section:load', (event) => initialiseTabs(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article-gp-comparison"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.gp-article').forEach((article) => {
    const progress = article.querySelector('.gp-article__progress span');
    if (!progress) return;
    const updateProgress = () => {
      const rect = article.getBoundingClientRect();
      const total = Math.max(article.offsetHeight - window.innerHeight, 1);
      const travelled = Math.min(Math.max(-rect.top, 0), total);
      progress.style.width = `${(travelled / total) * 100}%`;
    };
    updateProgress();
    window.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
